import { Typography } from "@material-ui/core"
import React from "react"

interface Props {
    children: React.ReactNode
    style?: React.CSSProperties
    className?: string
}

class ValidationMessage extends React.Component<Props> {
    render() {
        return (
            <Typography
                variant="body2"
                style={{
                    color: "#f44336",
                    fontSize: "0.75rem",
                    margin: "8px 12px 0",
                    lineHeight: "1em",
                    ...(this.props.style || {}),
                }}
                className={this.props.className}>
                {this.props.children}
            </Typography>
        )
    }
}

export default ValidationMessage
